import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DriverRecordRequestService } from '../../../services/driverrecordrequest.service';
import { IWizard } from '../../../interfaces/iwizard';
import { WizardSteps } from '../../../interfaces/wizard-steps';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from '../../../services/authentication.service';
import DriverDTO from 'src/app/interfaces/driverDTO';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-disclaimers',
    templateUrl: './disclaimers.component.html',
    styleUrls: ['./disclaimers.component.scss'],
    standalone: false
})
export class DisclaimersComponent {

     form!: FormGroup;
     public wizard!: IWizard;
     _step = 3;

     get initials() { return this.form!.get('initials'); }

     constructor(public service: DriverRecordRequestService, private authenticationService: AuthenticationService, private route: ActivatedRoute) {
          this.wizard = this.service.getWizard();
     }

     ngOnInit(): void {
          setTimeout(() => this.scrollToTop(), 500);
          // Define inputs with validations 
          this.form = new FormGroup({
               initials: new FormControl(this.service.driverRequest.driverInitials, [
                    Validators.required,
                    Validators.minLength(2),
                    Validators.maxLength(3),
                    Validators.pattern(/^[A-Za-z]+$/) 
               ])
          });

          if (this.service.isReorder() && this.service.userProfile?.userData?.userName) {
               const driverPromise = this.service.getDriverByUsername(this.service.userProfile.userData.userName);
               driverPromise.then((response: DriverDTO | any) => {
                    if (response && response.id) {
                         this.service.hydrateDriverRequest(response, (this.service.userProfile?.userData?.userName ?? ''))
                    }
               })
          }

          if (this.service.isReorder()) {
               this._step = 1;
          }
     }

     ngOnDestroy() {
          this.service.driverRequest.driverInitials = this.form.get('initials')?.value;
          this.service.saveToLocal();
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     @HostListener('window:beforeunload', ['$event'])
     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }

     getStepForPercentComplete() {
          if (this.service.isReorder() && (this._step === 4 || this._step === 5)) {
               return 2;
          } else {
               return this._step;
          }
     }
}
